import { TSupportPage } from '@/reseller/reseller.types';

export const SUPPORT_PAGES: Record<TSupportPage, string> = {
  documentation: 'https://docs.softwaredefinedautomation.io/app',
  customer_support:
    'https://softwaredefinedautomation.atlassian.net/servicedesk/customer/portal/3',
  security_incident_reporting:
    'https://softwaredefinedautomation.atlassian.net/servicedesk/customer/portal/3/group/4/create/44',
};
